export const fetchData = async (userToken: String) => {
  // console.log("fetchData function called inside booking.tsx ");
  const url = "https://api-dev.spark.hushl.in/experience/booking/user-bookings";

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
      },
      // Additional options can be added here, such as body for POST requests
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    // console.log("Error fetching data ", error);
    throw error;
  }
};

export const getUserSingleExperience = async (exp_Id: string) => {
  // console.log(
  //   `Inside getUserSingleExperience function called forexp_Id: ${exp_Id}`
  // );

  const url = `https://api-dev.spark.hushl.in/experience/${exp_Id}`;
  // const token = 'your_token_here'; // Replace with your actual token

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    // console.log("Data.experience ", data.experience);
  } catch (error) {
    // console.log("Error fetching data ", error);
    throw error;
  }
};
